import { DateRange } from "react-date-range";
import { createDate, addDaysToDate, addYearsToDate, formatDate } from "@client.utils/dateUtils";
import PropTypes from "prop-types";
import React, { useState, forwardRef } from "react";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DateFormat } from "@client.enums/dateTypes";

const CustomRangeFilter = forwardRef(({ startDate, endDate }, ref) => {
  const [state, setState] = useState([
    {
      startDate: startDate ? createDate(startDate) : new Date(),
      endDate: endDate
        ? createDate(endDate)
        : addDaysToDate(new Date(), 7),
      key: "selection",
    },
  ]);

  React.useImperativeHandle(ref, () => ({
    managementItem: {
      dateFrom: formatDate(state[0].startDate, DateFormat),
      dateTo: formatDate(state[0].endDate, DateFormat),
    },
    validate: () => {
      return true;
    },
  }));

  return (
    <DateRange
      onChange={(item) => {
        setState([item.selection]);
      }}
      minDate={addYearsToDate(new Date(), -1)}
      moveRangeOnFirstSelection={false}
      ranges={state}
      months={2}
      direction="horizontal"
    />
  );
});

CustomRangeFilter.displayName = "CustomRangeFilter";

CustomRangeFilter.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

export default CustomRangeFilter;
